<template>
    <div class="grid-layout-container mt-0 pa-0">
        <v-row align="start" class="mt-0">
            <v-col cols="4" class="py-0">
                <Users @selection-changed="handleSelectionChanged" />
            </v-col>
            <v-col cols="8" class="py-0">
                <GridDrepturiAgenti v-if="selectedRow !== null && selectedRow !== undefined" :key="selectedRow"
                    :user-id="selectedRow" />
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import Users from '@/views/ADMIN/Users.vue';
import GridDrepturiAgenti from '@/views/Comercial/CRM/GridDrepturiAgenti.vue';

export default {
    name: 'PaginaUtilizatori',
    components: { GridDrepturiAgenti, Users },
    data() {
        return {
            selectedRow: null as number | null,
        };
    },
    methods: {
        handleSelectionChanged(row: any) {
            this.selectedRow = row?.ID ?? row?.id ?? null;
        },
    },
};
</script>
